import React from 'react'
import MailIcon from '../icons/MailIcon'

const FooterNewsletterAnmelden = ({ heading, body }) => (
  <div className="mb-16 md:mb-0 xl:mb-16">
    <MailIcon className="w-4.5 h-auto mb-2" />

    <div className="text-[15px] font-bold leading-normal mb-3">{heading}</div>
    <div
      className="text-[15px] link-wrapper"
      dangerouslySetInnerHTML={{ __html: body }}
    />
  </div>
)

export default FooterNewsletterAnmelden
